<template >
  <div class="over">
    <div
      class="container"
      style="position: relative; padding='10px'; max-width: 360px; background-color: rgba(0,0,0,0);"
    >
      <!-- <div class="row">
        <div
          class="col-12 text-center btnTuto px-2"
          style="background-color: rgba(255,255,255, 1);color: black;font-size: 16px;  min-height: 66px;"
      >-->
      <div v-if="slide === 0" class="captionDiv1 captionDiv rtl text-right">
        {{ lang }}{{ translation.slide0 }}
      </div>
      <div v-if="slide === 1" class="captionDiv2 captionDiv rtl text-right">
        {{ lang }}{{ translation.slide1 }}
      </div>
      <div v-if="slide === 2" class="captionDiv3 captionDiv rtl text-right">
        {{ lang }}{{ translation.slide2 }}
      </div>
      <div v-if="slide === 3" class="captionDiv4 captionDiv rtl text-right">
        {{ lang }}{{ translation.slide3 }}
      </div>
      <div v-if="slide === 4" class="captionDiv8 captionDiv rtl text-right">
        {{ lang }}{{ translation.slide4 }}
      </div>
      <div v-if="slide === 5" class="captionDiv5 captionDiv rtl text-right">
        {{ lang }}{{ translation.slide5 }}
      </div>
      <div v-if="slide === 6" class="captionDiv6 captionDiv rtl text-right">
        {{ lang }}{{ translation.slide6 }}
      </div>
      <div v-if="slide === 7" class="captionDiv7 captionDiv rtl text-right">
        {{ lang }}{{ translation.slide7 }}
      </div>
      <!-- </div>
      </div>-->
      <div>
        <b-carousel
          id="carousel-1"
          v-model="slide"
          :interval="0"
          no-wrap
          background="#ababab"
          img-width="1024"
          img-height="480"
          style="
            text-shadow: 1px 1px 2px #333;
            height: 50%;
            max-width: 330px;
            margin: 0 auto;
          "
          @sliding-start="onSlideStart"
          @sliding-end="onSlideEnd"
        >
          <b-carousel-slide>
            <img
              slot="img"
              class="d-block w-95 img-fluid"
              width="1024"
              height="480"
              src="../../static/img/number.png"
              alt
            />
          </b-carousel-slide>
          <b-carousel-slide>
            <img
              slot="img"
              class="d-block img-fluid w-95"
              width="1024"
              height="480"
              src="../../static/img/map2.png"
              alt
            />
          </b-carousel-slide>
          <b-carousel-slide>
            <img
              slot="img"
              class="d-block img-fluid w-95"
              width="1024"
              height="480"
              src="../../static/img/panneau.png"
              alt
            />
          </b-carousel-slide>
          <b-carousel-slide>
            <img
              slot="img"
              class="d-block img-fluid w-95"
              width="1024"
              height="480"
              src="../../static/img/missingWord.png"
              alt
            />
          </b-carousel-slide>
          <b-carousel-slide>
            <img
              slot="img"
              class="d-block img-fluid w-95"
              width="1024"
              height="480"
              src="../../static/img/skipPoint.png"
              alt
            />
          </b-carousel-slide>
          <b-carousel-slide>
            <img
              slot="img"
              class="d-block img-fluid w-95"
              width="1024"
              height="480"
              src="../../static/img/menu.png"
              alt
            />
          </b-carousel-slide>
          <b-carousel-slide>
            <img
              slot="img"
              class="d-block img-fluid w-95"
              width="1024"
              height="480"
              src="../../static/img/backToGame.png"
              alt
            />
          </b-carousel-slide>
          <b-carousel-slide>
            <img
              slot="img"
              class="d-block img-fluid w-95"
              width="1024"
              height="480"
              src="../../static/img/mapWelcomePage.png"
              alt
            />
          </b-carousel-slide>
        </b-carousel>
      </div>

      <div class="row fixed-bottom mb-3 footer">
        <!-- <div class="col-1" v-if="slide != 5"></div> -->
        <div
          v-if="slide === 7"
          class="text-center btnTuto rtl col-4"
          style="
            background-color: rgb(84, 163, 49);
            border: 1px solid white;
            border-radius: 50px;
            height: 80px;
            width: 80px;
            padding-top: 26px;
            color: white;
            font-weight: bold;
            top: 5px;
            margin: auto;
          "
          @click="startGame"
        >
          {{ translation.playButton }}
        </div>
        <div class="row" v-else>
          <div class="col-9 pl-5" style="padding-top: 17px">
            <div class="row">
              <div class="col-1">
                <!-- <div class="smallPoint activePoint"></div> -->
                <div
                  v-bind:class="[slide === 0 ? activeClass : '', notActive]"
                ></div>
              </div>
              <div class="col-1">
                <div
                  v-bind:class="[slide === 1 ? activeClass : '', notActive]"
                ></div>
              </div>
              <div class="col-1">
                <div
                  v-bind:class="[slide === 2 ? activeClass : '', notActive]"
                ></div>
              </div>
              <div class="col-1">
                <div
                  v-bind:class="[slide === 3 ? activeClass : '', notActive]"
                ></div>
              </div>
              <div class="col-1">
                <div
                  v-bind:class="[slide === 4 ? activeClass : '', notActive]"
                ></div>
              </div>
              <div class="col-1">
                <div
                  v-bind:class="[slide === 5 ? activeClass : '', notActive]"
                ></div>
              </div>
              <div class="col-1">
                <div
                  v-bind:class="[slide === 6 ? activeClass : '', notActive]"
                ></div>
              </div>
              <div class="col-1">
                <div
                  v-bind:class="[slide === 7 ? activeClass : '', notActive]"
                ></div>
              </div>
            </div>
          </div>
          <!-- <div class="col-1" v-if="slide != 5"></div> -->

          <div class="col-2">
            <svg
              style="
                font-size: 38px;
                color: white;
                border-radius: 50px;
                position: relative;
              "
              v-if="slide != 7"
              @click="slide = slide + 1"
              width="1em"
              height="1em"
              viewBox="0 0 16 16"
              class="bi bi-arrow-right-short"
              fill="currentColor"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill-rule="evenodd"
                d="M8.146 4.646a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.793 8 8.146 5.354a.5.5 0 0 1 0-.708z"
              />
              <path
                fill-rule="evenodd"
                d="M4 8a.5.5 0 0 1 .5-.5H11a.5.5 0 0 1 0 1H4.5A.5.5 0 0 1 4 8z"
              />
            </svg>
            <!-- <path
              fill-rule="evenodd"
              d="M16 8A8 8 0 1 1 0 8a8 8 0 0 1 16 0zm-8.354 2.646a.5.5 0 0 0 .708.708l3-3a.5.5 0 0 0 0-.708l-3-3a.5.5 0 1 0-.708.708L9.793 7.5H5a.5.5 0 0 0 0 1h4.793l-2.147 2.146z"
            />
          </svg>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
/* eslint-disable */
export default {
  data() {
    return {
      // loading: false
      slide: 0,
      sliding: null,
      activeClass: "activePoint",
      notActive: "smallPoint",
      translation: {
        slide0:
          "L'application vous indique vers quel point vous devez vous rendre",
        slide1: "Trouver le point sur la carte",
        slide2: "Allez y et trouvez la pancarte que vous voyez sur l'image",
        slide3: "Ecrivez le mot manquant sur l'image",
        playButton: "Jouer!",
      },
    };
  },
  computed: {
    lang() {
      return this.translate(this.$store.getters.lang);
    },
    welcomePage() {
      return this.$store.getters.welcomePage;
    },
    buttonStartGame() {
      return this.$store.getters.welcomePage.buttonStartGame;
    },
    user() {
      // console.log("[computed] user", this.$store.getters.user)
      return this.$store.getters.user;
    },
    loading() {
      console.log(
        "[computed] this.$store.getters.loading",
        this.$store.getters.loading
      );
      if (this.$store.getters.points) {
        return true;
      } else {
        return false;
      }
    },
    timeNow() {
      return setInterval((_) => {
        let d = new Date();
        this.time = d.toLocaleTimeString("he");
      }, 1000);
    },
  },
  methods: {
    translate(lang) {
      switch (lang) {
        case "fr":
          this.translation = {
            slide0:
              "L'application vous indique vers quel point vous devez vous rendre",
            slide1: "Trouver le point sur la carte",
            slide2: "Allez y et trouvez la pancarte que vous voyez sur l'image",
            slide3: "Ecrivez le mot manquant sur l'image",
            playButton: "Jouer!",
          };
          console.log("french");
          break;
        case "en":
          this.translation = {
            slide0: "The app lets you know to which point you need to go.",
            slide1: "Find the location on the map.",
            slide2: "Go there and find this sign.",
            slide3: "Enter the missing word.",
            playButton: "Play!",
          };
          console.log("english");

          // code block
          break;
        case "he":
          this.translation = {
            slide0: "היישומון נותן לכם את הנקודה שאליה אתם צריכים להגיע.",
            slide1: "מצאו את הנקודה על המפה.",
            slide2: "במקום, מצאו את השלט",
            slide3: "כתבו את המילה החסרה.",
            slide4: "אפשר לדלג על הנקודה בלחיצה כאן, אבל תפסידו 10 נקודות.",
            slide5: "אפשר לפתוח תפריט מכאן",
            slide6: "אם יצאתם מהמשחק, תמיד אפשר לחזור על ידי לחיצה כאן",
            slide7:
              "על המפה, בלחיצה על הכפתור, אתם יכולים לראות את המיקום שלכם. שימו לב ! משתמשי אייפון, עברו אל 'הגדרות' > 'פרטיות' > 'שירותי מיקום'. ודאו שהאפשרות 'שירותי מיקום' מופעלת כדי לראות את המיקום שלכם. בנוסף, נא לאשר שירותי מיקום גם בספארי 'הגדרות' > 'פרטיות' > 'שירותי מיקום'.  ",
            playButton: "לשחק!",
          };
          console.log("hebreu");

          // code block
          break;
        default:
        // code block
      }
    },
    onSlideStart(slide) {
      this.sliding = true;
    },
    onSlideEnd(slide) {
      this.sliding = false;
    },
    startGame() {
      if (localStorage.getItem("navigationName") == "yaffoCroisades") {
        this.$router.push("/paymentPage");
      } else {
        //this.$router.push("/startGame");
        this.$router.push("/testing");
      }
    },
  },
};
</script>

<style scoped>
#carousel-1 {
  text-shadow: 1px 1px 2px #333;
  height: 50%;
  max-width: 330px;
  margin: 0 auto;
  top: 54px;
  position: absolute;
}
.footer {
  max-width: 590px;
  display: block;
  margin: 0 auto;
}
.smallPoint {
  width: 5px;
  height: 5px;
  border-radius: 60px;
  background: white;
  opacity: 0.5;
}
.activePoint {
  opacity: 1;
}
.carousel {
  width: 640px;
  height: 100px;
}
.tuto1 {
  height: 52px;
  width: 52px;
  border: red 3px solid;
  position: absolute;
  top: 142px;
  left: 153px;
  z-index: 10;
  animation: tuto1 2s ease-in-out;
}
.tuto2 {
  height: 47px;
  width: 167px;
  border: red 3px solid;
  position: absolute;
  top: 0px;
  left: 178px;
  z-index: 10;
  animation: tuto2 2s ease-in-out;
}
.tuto3 {
  height: 211px;
  width: 319px;
  border: red 3px solid;
  position: absolute;
  top: 257px;
  left: 20px;
  z-index: 10;
  animation: tuto3 2s ease-in-out;
}
.tuto4 {
  height: 46px;
  width: 322px;
  border: red 3px solid;
  position: absolute;
  top: 466px;
  left: 20px;
  z-index: 10;
  animation: tuto4 2s ease-in-out;
}
.captionDiv1 {
  top: 193px;
  margin-left: 2vw;
  width: 241px;
}
.captionDiv2 {
  top: 484px;
  right: 131px;
  height: 44px;
}
.captionDiv1:after {
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  left: 61%;
  top: -20px;
  border: 10px solid transparent;
  /* border-left: 10px solid white; */
  /* border-right: 10px solid white; */
  /* border-top: 10px solid white; */
  border-bottom: 10px solid white;
}
.captionDiv2:after {
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  left: 10%;
  top: 44px;
  border: 10px solid transparent;
  /* border-left: 10px solid white; */
  /* border-right: 10px solid white; */
  border-top: 10px solid white;
}
.captionDiv3 {
  top: 165px;
  right: 86px;
  width: 187px;
}
.captionDiv3:after {
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  left: 45%;
  bottom: -20px;
  border: 10px solid transparent;
  /* border-left: 10px solid white; */
  /* border-right: 10px solid white; */
  border-top: 10px solid white;
}
.captionDiv4 {
  top: 415px;
  right: 68px;
}
.captionDiv4:after {
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  left: 48%;
  bottom: -20px;
  border: 10px solid transparent;
  /* border-left: 10px solid white; */
  /* border-right: 10px solid white; */
  border-top: 10px solid white;
  /* border-bottom: 10px solid white; */
}
.captionDiv7 {
  top: 160px;
  left: 20px;
  width: 239px;
}
.captionDiv7:after {
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  left: 6%;
  top: -20px;
  border: 10px solid white;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid transparent;
}
.captionDiv8 {
  top: 394px;
  left: 108px;
  width: 239px;
}
.captionDiv8:after {
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  right: 10%;
  top: 68px;
  border: 10px solid transparent;
  /* border-left: 10px solid white; */
  /* border-right: 10px solid white; */
  border-top: 10px solid white;
}
.captionDiv5 {
  top: 65px;
  right: 3px;
  width: 207px;
}
.captionDiv5:after {
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  right: 8%;
  right: 8%;
  top: -20px;
  border: 10px solid white;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid transparent;
}
.captionDiv6 {
  top: 161px;
  right: 14px;
  width: 290px;
}
.captionDiv6:after {
  content: "";
  position: absolute;
  height: 0;
  width: 0;
  left: 65%;
  top: -20px;
  border: 10px solid white;
  border-left: 10px solid transparent;
  border-right: 10px solid transparent;
  border-top: 10px solid transparent;
}
.captionDiv {
  animation: getOpacity 1s;
  position: absolute;
  z-index: 5;
  font-size: 16px;
  background: white;
  border-radius: 10px;
  padding: 10px;
}
@keyframes getOpacity {
  0% {
    opacity: 0;
  }
  100% {
    opacity: 1;
  }
}
.btnTuto {
  background-color: white;
  color: black;
  padding: 9px;
  font-size: 16px;
}
.over {
  top: 0px;
  left: 0px;
  font-size: 18px;
  width: 100vw;
  max-width: 590px;
  height: 120vh;
  background-color: rgba(0, 0, 0, 0.6);
  align-items: start;
}
.colorDiv {
  margin: 0 auto;
  display: block;
  height: 100px;
  width: 100px;
  font-size: 25px;
  padding-top: 30px;
}
.container {
  /* margin-top: 16px; */
  background-color: rgba(248, 242, 242, 0.2);
  font-size: 20px;
  height: calc(100vh - 82px);
}
.colorBtn {
  border-radius: 36px;
  height: 56px;
  color: white;
}
.fullWidth {
  width: 95%;
  display: block;
  margin: 0px auto;
}
.rtl {
  direction: rtl;
}
.userName {
  font-size: 25px;
  text-align: right;
  color: black;
  /* text-shadow: 0 0 20px rgba(10, 175, 230, 1), 0 0 20px rgba(10, 175, 230, 0); */
}
</style>
